<template>
   <div class="d-flex align-items-center my-3 mx-5">
      <strong>Cargando datos...</strong>
      <b-spinner class="ml-auto"></b-spinner>
   </div>
</template>

<script>
   export default {
      name: 'LoadSpinner-Widget',
   }
</script>